import { GraphQLErrors } from '@apollo/client/errors'
import { Translate } from '~/types/Translation'

type Status = 500 | 415 | 413 | 403 | 404 | 401 | 400 | 300 | 200

export enum GraphQLErrorCode {
  UNKNOWN = 'UNKNOWN',
  FORBIDDEN = 'FORBIDDEN',
  UNAUTHENTICATED = 'UNAUTHENTICATED',
}

export const getStatusCodeFromGraphQLErrors = (graphQLErrors?: GraphQLErrors): Status => {
  if (!Array.isArray(graphQLErrors)) {
    return 500
  }

  const [graphQLError] = graphQLErrors
  const { extensions = {} } = graphQLError || {}
  const { code = GraphQLErrorCode.UNKNOWN } = extensions

  switch (code) {
    case GraphQLErrorCode.FORBIDDEN:
      return 403
    case GraphQLErrorCode.UNAUTHENTICATED:
      return 401
    default:
      return 404
  }
}

// Returns a boolean that determines whether or not to render the error-template.
export const shouldRenderErrorTemplate = (statusCode: Status) => statusCode >= 300

export const getMessageFromStatusCode = (t: Translate, statusCode: Status) => {
  switch (statusCode) {
    case 400:
      return t('common:statusCode.badRequest')
    case 401:
      return t('common:statusCode.unauthorized')
    case 403:
      return t('common:statusCode.forbidden')
    case 413:
      return t('common:statusCode.entityTooLarge')
    case 415:
      return t('common:statusCode.unsupportedMediaType')
    default:
      return t('common:statusCode.internalServerError')
  }
}
